import { IPublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { loginRequest } from "../../authConfig";
import logo from "../../images/porterbrook-lockup-hero-rgb.svg";

function handleLogin(instance: IPublicClientApplication) {
    instance.loginRedirect(loginRequest).catch((e: any) => {
        console.error(e);
    });   
}

export const SignInButton = () => {
    const { instance } = useMsal();

    return (
        <Button
            variant="contained"
            color="primary"
            sx={{ minWidth: 160, px: 4, py: 1.2 }}
            onClick={() => handleLogin(instance)}
        >
            Sign in
        </Button>
    );
}

const FullpageContainer = styled('div')(() => ({
    backgroundColor: "#010144",
    backgroundImage: "linear-gradient(105deg, rgba(1, 1, 68, 0.92), rgba(1, 1, 68, 0.72) 52%, rgba(255, 98, 58, 0.18)), url(" + process.env.PUBLIC_URL + "/porterbrook-login-background.svg)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    flexFlow: "column",
    minHeight: "100vh",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "clamp(2rem, 5vw, 5rem)"
}));

const SignInPanel = styled('main')(() => ({
    backgroundColor: "#FFFFFF",
    borderTop: "6px solid #ff623a",
    boxShadow: "0 24px 60px rgba(0, 0, 0, 0.24)",
    maxWidth: "560px",
    padding: "clamp(2rem, 4vw, 3.5rem)",
    width: "min(100%, 560px)"
}));

const SignInLogo = styled('img')(() => ({
    display: "block",
    height: "auto",
    marginBottom: "1.25rem",
    width: "min(100%, 430px)"
}));

const SignInSubheading = styled('div')(() => ({
    borderLeft: "4px solid #ff623a",
    marginBottom: "1.75rem",
    maxWidth: "430px",
    paddingLeft: "1rem",
    width: "min(100%, 430px)"
}));

export const SignIn = () => {
    return (
        <FullpageContainer>
            <SignInPanel>
                <SignInLogo src={logo} alt="Porterbrook" />
                <SignInSubheading>
                    <Typography component="h1" variant="subtitle1" sx={{
                        color: "#010144",
                        fontWeight: 600,
                        lineHeight: 1.35,
                        margin: 0,
                        opacity: 0.82
                    }}>
                        Spares Inventory Management
                    </Typography>
                </SignInSubheading>
                <SignInButton />
            </SignInPanel>
        </FullpageContainer>
    );
}
